const themeContract = {
  argos: {
    apr: {
      background: 'brand-1',
      border: 'brand-1',
      color: 'white'
    }
  },
  habitat: {
    apr: {
      background: 'brand-1',
      border: 'brand-1',
      color: 'white'
    }
  }
}

export { themeContract }
